import { PassageTaskFormDto, type PassageTaskFormInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-task/passage-task-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Passage task create API request body - DTO signature */
export interface PassageTaskCreateInterface extends PassageTaskFormInterface {
  /** If defined and bigger than zero then created task will cloned {@link PassageTaskCreateInterface.repeat} times with date incrementation */
  repeat?: number;
}

/** Passage task create API request body - DTO schema */
export const PassageTaskCreateDto = SerdeDtoClass.from<PassageTaskFormInterface, PassageTaskCreateInterface>(
  PassageTaskFormDto,
  PacsDtoKeysEnum.PASSAGE_TASK_CREATE_DTO,
  {
    repeat: {
      optional: true,
      label: 'Повторить проход на следующие дни',
      serializer: yup
        .number()
        .min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    },
  },
);
